
































import { Vue, Component, Prop } from 'vue-property-decorator'
import PalletPatternDetails from '../PalletPatternDetails.vue'
import { PalletPattern, ISnackbar, Settings } from '@/model'
import Units from '@/api/utils/units'
import { mapGetters } from 'vuex'
import CancelValidationDialog from '@/components/CancelValidationDialog.vue'
import { errorHandler, getUrl } from '@/api/utils/http-helpers'
import axios from 'axios'

@Component({
  components: {
    PalletPatternDetails: PalletPatternDetails,
    CancelValidationDialog: CancelValidationDialog
  },
  computed: {
    ...mapGetters('settings', ['isPatternValidationEnabled', 'settings'])
  }
})
export default class SimpleFormG extends Vue {
  @Prop({ required: true }) private value!: PalletPattern
  @Prop({ required: true }) private parentBus!: Vue
  @Prop({ required: true }) private guid!: string
  @Prop({ required: true }) private units!: Units

  private palletPattern: PalletPattern = JSON.parse(JSON.stringify(this.value))
  private isPatternValidationEnabled!: boolean
  private settings!: Settings
  private verifyInProgress: boolean = false
  private snackbar: ISnackbar = { show: false, color: '', text: '', timeout: 10000 }

  private mounted () {
    this.parentBus.$on('stepper_next', this.next)
    this.parentBus.$on('stepper_previous', this.previous)
    this.validatePattern()
    // console.log('[DEBUG] pattern', this.palletPattern)
  }

  private beforeDestroy () {
    this.parentBus.$off('stepper_next', this.next)
    this.parentBus.$off('stepper_previous', this.previous)
  }

  private next () {
    this.$emit('next', this.palletPattern)
  }

  private previous () {
    this.$emit('previous', this.palletPattern)
  }

  get validationSecondsPerBox() {
    return this.settings && this.settings.ppParams && this.settings.ppParams.timeoutSeconds
      ? this.settings.ppParams.timeoutSeconds
      : 2
  }

  get validationProgress() {
    const guid = this.palletPattern && this.palletPattern.guid
    const getter = this.$store.getters['palletpatterns/validationProgressByGuid']
    return guid && getter ? getter(guid) : null
  }

  private async validatePattern() {
    if (!this.isPatternValidationEnabled) {
      return
    }

    const url = getUrl('/pallet-patterns/' + this.palletPattern.guid + '/validate-pattern')
    this.$store.dispatch('palletpatterns/clearValidationProgress', this.palletPattern.guid)
    this.verifyInProgress = true
    await axios
        .post(url)
        .then( (resp) => {
          console.log('[DEBUG] validation result', resp.data.status)
          this.$store.dispatch ('settings/setStatusSocketServer', 'available')
        })
        .catch(e => {
          if (e.response!.status === 502) {
            this.snackBarHandler(true, 'error', String(this.$t('patternList.badGateway')))
            this.$store.dispatch ('settings/setStatusSocketServer', 'unavailable')
          } else if (e.response!.status === 504) {
            const msg = e.response!.data!.message!.toString()
            const timeout = msg.substring(msg.indexOf('(') + 1, msg.indexOf(')'))
            this.snackBarHandler(true, 'error', String(this.$t('patternList.gatewayTimeout', [timeout])))
            this.$store.dispatch ('settings/setStatusSocketServer', 'unknown')
          } else {
            this.snackBarHandler(true, 'error', String(this.$t('patternList.validationNOK')))
            errorHandler(e.toString())
            this.$store.dispatch ('settings/setStatusSocketServer', 'available')
          }
        })
        .finally( () => {
          this.$store.dispatch('palletpatterns/clearValidationProgress', this.palletPattern.guid)
          this.verifyInProgress = false
        })
    await this.updatePalletPattern()
  }

  private async cancelValidation() {
    const url = getUrl('/pallet-patterns/' + this.palletPattern.guid + '/cancel')
    await axios
        .post(url, null, { params: {action: 'validate'} })
        .then(() => {
          this.snackBarHandler(true, 'info', String(this.$t('patternList.validationCanceled')))
        })
        .catch(e => errorHandler(e.toString()))
        .finally(() => {
          this.$store.dispatch('palletpatterns/clearValidationProgress', this.palletPattern.guid)
          this.verifyInProgress = false
        })
    await this.updatePalletPattern()
  }

  private async updatePalletPattern() {
    const url = getUrl(`/pallet-patterns/${this.palletPattern.guid}`)
    await axios
        .get(url)
        .then(resp => {
          if (resp.data) { this.palletPattern = resp.data }
        })
  }

  private snackBarHandler (state: boolean, color: string, text: string) {
    this.snackbar.show = state
    this.snackbar.color = color
    if (text && text !== '') {
      this.snackbar.text = text
    }
  }
}
